import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'stretch',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  },
  valueRow: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: 0.25,
  },
  delta: {
    alignSelf: 'center',
    flexShrink: 0,
  },
} satisfies Record<string, SxProps<Theme>>
